import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/deploy-frontend/src/app/[lang]/pricing/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SubscriptionPlansContainer"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/containers/SubscriptionPlansContainer/SubscriptionPlansContainer.tsx");
